import { render, staticRenderFns } from "./ModalBootstrap.vue?vue&type=template&id=567ca5c6&scoped=true&"
import script from "./ModalBootstrap.vue?vue&type=script&lang=js&"
export * from "./ModalBootstrap.vue?vue&type=script&lang=js&"
import style0 from "./ModalBootstrap.vue?vue&type=style&index=0&id=567ca5c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567ca5c6",
  null
  
)

export default component.exports